import * as React from 'react';

import {CloseButton} from '../button/close-button/close-button';
import {Stack} from '../layout/stack/stack';
import {Body} from '../typography/body';

type Props = {
    name: string;
    type?: string;
    onRemove: () => void;
};

export function CustomFieldListItem(props: Props) {
    return (
        <div className='pad-8'>
            <Stack isHorizontal={true} alignItems='center' justifyContent='space-between'>
                <Stack spacing={2}>
                    <Body size='small'>{props.name}</Body>
                    {props.type && (
                        <Body size='small' color='light'>
                            {props.type}
                        </Body>
                    )}
                </Stack>
                <Stack isHorizontal={true} alignItems='center' spacing={4}>
                    <CloseButton variant='dark' onClick={props.onRemove} size={10} />
                </Stack>
            </Stack>
        </div>
    );
}
